export class DispatchMerge
{
    sourceDispatchId: any = null;
    sourceDispatchNumber: string = null;
    destDispatchId: any = null;
    destDispatchNumber: string = null;
    locationId: any = null;
}
